// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  
  // API Configuration
  API_BASE_URL: 'https://rwsq50ra75.execute-api.us-east-1.amazonaws.com/prod/',
  API_KEY: 'bzKR7LFt215IoBaUMgELj9hQ5YyZJOAS11L2nJr7',
  
  // Cognito Configuration
  COGNITO_USER_POOL_ID: 'us-east-1_KzFiCY0Zj',
  COGNITO_CLIENT_ID: '7m49o03aod8c2c1smhu6tadspd',
  
  // WebSocket Configuration
  websocketEndpoint: 'wss://0ayp02m9t0.execute-api.us-east-1.amazonaws.com/prod',
  
  // ReCAPTCHA Configuration
  recaptcha: {
    siteKey: '6LfBmqorAAAAAGysdVvgHPj7JmpwNXN-8Qc5mvN5'
  },
  
  // App Configuration
  app: {
    maxFileSize: 4 * 1024 * 1024, // 4MB
    allowedFileTypes: ['application/pdf']
  },
  
  // Features Configuration
  features: {
    websocketEnabled: true,
    realTimeUpdates: true,
    cvAnalysis: true,
    jobMatching: true,
    trainingPaths: true
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
